export class ConstantsSonstige {
  //
  static readonly PROGRAMM_START_YEAR: number = 2025;
  static readonly PROGRAM_NAME: string = 'Baukost4';
  static readonly PROGRAM_VERSION: string = '2.01';
  static readonly PROGRAM_IS_ENTWICKLUNG: boolean = true;
  static readonly PROGRAM_LOG_PROOGRAM_EBENE: string = 'WEB';
  //
 
  static readonly STARTUP_PARAMETER = "idGebaeude";
}
